import { ApiKy } from './index'
import { DownloadCsvSearchParams } from '~/types/credit-notes'

const { stripEmptyKeys } = useHelpers()

export default class Api extends ApiKy {
  get(id: string) {
    return this.ky.get(`${this.url}/${id}/pdf`)?.json<{ downloadUrl: string }>()
  }

  downloadPdfs(creditNoteIds: string[]) {
    return this.ky.post(`${this.url}/download-pdfs`, {
      json: { creditNoteIds },
    })
  }

  downloadCsv(searchParams: DownloadCsvSearchParams) {
    const params = stripEmptyKeys(searchParams)
    return this.ky.get(`${this.url}/download-csv`, {
      searchParams: params,
    })
  }
}
